export default __webpack_public_path__ + "static/media/menuActive.d7c2f7d6.svg";